import { Tag, Typography } from "antd";
import { Util } from "../../../../treasury/treasuryBill/helper/helper";
const { Text, Link, Title, Paragraph } = Typography;
export default function PreviewTable({ data }) {
  return (
    <div
      style={{
        border: "1px solid #EAECF0",
        borderRadius: 12,
        overflow: "hidden",
        margin: 0,
      }}
      className="no-margin"
    >
      {data?.map((item, i) => {
        return (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              border: "",
              borderBottom: i !== data.length - 1 ? "1px solid #EAECF0" : "0",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <div
              style={{
                backgroundColor: "#F9FAFB",
                paddingInline: 25,
                paddingBlock: 12,

                fontWeight: "500",
                borderRight: "1px solid #f0f0f0",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
              }}
            >
              {item.name}
            </div>
            <div
              style={{
                paddingInline: 25,
                paddingBlock: 12,
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {!item.type ? (
                <div
                  style={{
                    color: "#9F1AB1",
                    backgroundColor: "#FDF4FF",
                    border: "1px solid #F6D0FE",
                    borderRadius: 9999,
                    paddingInline: 12,
                    paddingBlock: 4,
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                  }}
                >
                  {Util.capitalizeFirstLetter(item?.labelValue)}
                </div>
              ) : item.type === 1 ? (
                <Text
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item?.prefix ?? ""} {Util.capitalizeFirstLetter(item?.labelValue)}
                  {item?.suffix ?? ""}{" "}
                </Text>
              ) : item.type === 2 ? (
                <div
                  style={{
                    color: "#9F1AB1",
                    backgroundColor: "#FDF4FF",
                    border: "1px solid #F6D0FE",
                    borderRadius: 9999,
                    paddingInline: 12,
                    paddingBlock: 4,
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                  }}
                >
                  {Util.capitalizeFirstLetter(item?.labelValue ? "Yes" : "No")}
                </div>
              ) : (
                item.type === 3 && (
                  <div>
                    {item?.items?.map((items, index) => {
                      if (items)
                        return (
                          <Tag
                            key={index}
                            style={{
                              color: "#9F1AB1",
                              backgroundColor: "#FDF4FF",
                              border: "1px solid #F6D0FE",
                              borderRadius: 9999,
                              paddingInline: 12,
                              paddingBlock: 2,
                              fontSize: 14,
                              fontWeight: 600,
                              marginBlock: 5,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                            }}
                          >
                            {Util.capitalizeFirstLetter(items?.labelValue)}
                          </Tag>
                        );
                    })}
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
